module.exports = __webpack_public_path__ + "img/album14_06.86793621.jpg";